import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { useState } from "react";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { RootState } from "../../../../../store/app";

/**
 * Renders a listing component for the Career Group Management module with action buttons.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - The module information.
 * @param {Function} props.handleViewClick - The function to handle view click use for viewing the details of a record.
 * @param {Function} props.handleDeleteClick - The function to handle delete click use for deleting the details of a record.
 * @param {Function} props.handleEditClick - The function to handle edit click use for editing the details of a record.
 * @return {JSX.Element} The rendered listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const careerGroup = useAppSelector(
    (state: RootState) => state.careerGroup
  );
  const [statusData, setStatusData] = useState<any>();
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        columnDefs={columnDefs}
        rowData={careerGroup.rowData}
        onGridReadyWithDispatch={setGrid}
        components={{
          ActionRenderer,
        }}
        context={{ setStatusData }}
        paginationPageSize={careerGroup.perPage}
        cacheBlockSize={careerGroup.perPage}
      />
    </>
  );
};

export default Listing;
